import request from './request'

export function verificationCode(data) {
    return request({
        url: '/user/create-vcode',
        method: 'post',
        data
    })
}

export function login(data) {
    return request({
        url: '/user/verify-vcode',
        method: 'post',
        data
    })
}

export function getList() {
    return request({
        url: '/qrcode/board-qrcode',
        method: 'get'
    })
}

export function postMd5(data) {
    return request({
        url: '/box',
        method: 'post',
        data
    })
}

